import {TeamAppsView} from 'views/teams/TeamAppsView';

export const TeamApps = () => <TeamAppsView />;
